if (!customElements.get('x-tabs')) {
  class Tabs extends HTMLElement {
    constructor() {
      super();
      this.tabSelector = 'x-tab';
      this.isAnimating = false;
    }

    connectedCallback() {
      this.tabs = this.querySelectorAll(this.tabSelector);
      this.activeTab = this.tabs[0];
    }

    changeTab(selectedTab) {
      if (this.isAnimating) return;

      this.setAnimating(true);
      this.activeTab.hide();
      selectedTab.show();
      this.activeTab = selectedTab;
    }

    setAnimating(animating = true) {
      this.isAnimating = animating;
      this.classList.toggle('is-animating', animating);
    }
  }

  customElements.define('x-tabs', Tabs);

  class CarouselTabs extends Tabs {
    constructor() {
      super();
      this.tabSelector = 'carousel-tab';
    }
  }

  customElements.define('carousel-tabs', CarouselTabs);

  class Tab extends ElementBase {
    constructor() {
      super();
      this.parentSelector = 'x-tabs';
      this.content = document.getElementById(this.getAttribute('aria-controls'));
      this.addListener(this, 'click', this.onClick.bind(this));
    }

    connectedCallback() {
      super.connectedCallback();
      this.parent = this.closest(this.parentSelector);
    }

    defaults() {
      return {
        ease: 'power1.out',
        duration: 0.4,
      }
    }

    isVisible() {
      return this.getAttribute('aria-selected') === 'true';
    }

    onClick() {
      if (this.isVisible()) return;

      this.parent.changeTab(this);
    }

    show() {
      const { ease, duration } = this.options;

      this.setAttribute('aria-selected', true);
      this.content.setAttribute('aria-hidden', false);
      gsap.fromTo(this.content, { opacity: 0 }, { opacity: 1, ease, duration, onComplete: () => this.parent.setAnimating(false) });
    }

    hide() {
      const { ease, duration } = this.options;

      this.setAttribute('aria-selected', false);
      gsap.set(this.content, { position: 'absolute', top: 0, width: '100%', zIndex: 2 });
      gsap.to(this.content, {
        opacity: 0,
        ease,
        duration,
        onComplete: () => {
          this.content.setAttribute('aria-hidden', true);
          gsap.set(this.content, { clearProps: 'all' });
        },
      });
    }

    toggle() {
      this.isVisible() ? this.hide() : this.show();
    }
  }

  customElements.define('x-tab', Tab);

  class CarouselTab extends Tab {
    constructor() {
      super();
      this.parentSelector = 'carousel-tabs';
    }

    defaults() {
      return {
        ease: 'power3.inOut',
        duration: 0.8,
        stagger: 0.08,
      };
    }

    show() {
      const { ease, duration, stagger } = this.options;
      const targets = this.content.querySelectorAll('.card-wrapper:not(.is-hidden) .card');

      this.setAttribute('aria-selected', true);
      this.content.setAttribute('aria-hidden', false);
      gsap.fromTo(
        targets,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          stagger,
          ease,
          duration,
          onComplete: () => {
            this.parent.setAnimating(false);
            gsap.set(targets, { clearProps: 'all' });
          },
        }
      );
    }

    hide() {
      const { ease, duration, stagger } = this.options;
      const targets = this.content.querySelectorAll('.card-wrapper:not(.is-hidden) .card');

      this.setAttribute('aria-selected', false);
      gsap.set(this.content, { position: 'absolute', top: 0, width: '100%', zIndex: -1 });

      // Fade out option
      gsap.fromTo(
        targets,
        {
          opacity: 1,
        },
        {
          opacity: 0,
          stagger,
          ease,
          duration,
          onComplete: () => {
            this.content.setAttribute('aria-hidden', true);
            gsap.set([this.content, targets], { clearProps: 'all' });
          },
        }
      );
    }
  }

  customElements.define('carousel-tab', CarouselTab);
}